export type CreditCostEstimateRange = {
  min?: number;
  max?: number;
  avg?: number;
};

type CreditEstimateInput = {
  estimatedCreditCost?: number;
  creditCostEstimateRange?: CreditCostEstimateRange;
};

export const roundUpToNearest100 = (value?: number) => {
  if (typeof value !== "number") return undefined;
  return Math.ceil(value / 100) * 100;
};

export const formatCreditNumber = (value?: number) => {
  if (typeof value !== "number" || Number.isNaN(value) || value <= 0) return undefined;
  return value.toLocaleString();
};

export const formatEstimatedCreditCost = ({ estimatedCreditCost, creditCostEstimateRange }: CreditEstimateInput) => {
  if (creditCostEstimateRange && creditCostEstimateRange.min !== undefined && creditCostEstimateRange.max !== undefined) {
    const roundedMin = roundUpToNearest100(creditCostEstimateRange.min);
    const roundedMax = roundUpToNearest100(creditCostEstimateRange.max);
    const formattedMin = formatCreditNumber(roundedMin);
    const formattedMax = formatCreditNumber(roundedMax);

    if (formattedMin && formattedMax) {
      return `${formattedMin} - ${formattedMax}`;
    }
  }

  const roundedCreditCost = roundUpToNearest100(estimatedCreditCost);
  return formatCreditNumber(roundedCreditCost);
};
